import React, { Component } from "react";
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import "./../../View.css";
import "./../../Grid.css";
import "./../../Form.css";
import "./../../App.css";
import "./ModuleSetup.css";
import SearchView from "../../widgets/SearchView";
import ModuleSetupSearchForm from './ModuleSetupSearchForm';
import ViewUtils from '../../ViewUtils';
import { ViewContainer } from "./../../View.jsx";
import CardLayout from '../../widgets/Card';
import withMenuPermission from "../../widgets/withMenuPermission";

const headCells = [
    { id: 'ModuleCode', numeric: false, disablePadding: true, label: 'QCTO Module ID' },
    { id: 'ModuleTitle', numeric: false, disablePadding: true, label: 'QCTO Module Title' }
];

const modelTemplate = [
    { Name: "ModuleCode", Value: "" },
    { Name: "ModuleTitle", Value: "" }
];



const utils = new ViewUtils();

class ModuleSetupSearch extends Component {
    constructor(props) {
        super(props);

        this.searchParameters = !utils.isNull(this.props.programmeId) ? [
            { Name: "ModuleCode", Value: "" },
            { Name: "ModuleTitle", Value: "" },
            { Name: "ProgrammeID", Value: this.props.programmeId },
            { Name: "ProgrammeType", Value: this.props.programmeType }
        ]
            :
            [
                { Name: "ModuleCode", Value: "" },
                { Name: "ModuleTitle", Value: "" }
            ];

        let model = !utils.isNull(this.props.programmeId) ?
            {
                ModuleCode: "",
                ModuleTitle: "",
                ProgrammeID: this.props.programmeId,
                ProgrammeType: this.props.programmeType
            }
            :
            {
                ModuleCode: "",
                ModuleTitle: ""
            }

        if (!utils.isNull(props.exclusions)) {
            model.Exclusions = props.exclusions;
            this.searchParameters.push({ Name: "Exclusions", Value: props.exclusions });
        }

        if (!utils.isNull(props.personId)) {
            model.PersonID = props.personId;
            this.searchParameters.push({ Name: "PersonID", Value: props.personId })
        }

        if (!utils.isNull(props.moduletype)) {
            model.ModuleType = props.moduletype;
            this.searchParameters.push({ Name: "ModuleType", Value: props.moduletype })
        }

        this.state = !utils.isNull(this.props.programmeId) ?
            {
                model: model,
                keyUpSwitch: false
            }
            :
            {
                model: model,
                keyUpSwitch: false
            };  

        //TODO: Add url for module removal
        this.deleteUrl = ""

        this.toolbarConfig = {
            items: [
                {
                    type: "buttonGroup",
                    buttons: [
                        { id: 'add', label: '', tooltip: 'Add', icon: 'AddIcon', visible: this.props.menuPermissionItem.Add },
                        { id: 'edit', label: '', tooltip: 'Edit', icon: 'EditIcon', disabled: true, visible: this.props.menuPermissionItem.Edit },
                        { id: "delete", label: '', tooltip: 'Remove Module', icon: "DeleteIcon", disabled: true, visible: this.props.menuPermissionItem.Delete}
                    ]
                }
            ]
        };
    }

    clearSearch(e) {
        let model = {
            ModuleCode: "",
            ModuleTitle: "",
            ProgrammeID: this.props.programmeId,
            ProgrammeType: this.props.programmeType
        };

        if (!utils.isNull(this.props.moduletype)) {
            model.ModuleType = this.props.moduletype;
        }

        this.setState({ model: model });
    }

    onkeyup(e) {
        if (e.charCode == 13) {
            this.setState({ keyUpSwitch: !this.state.keyUpSwitch })
        }
    }

  

    render() {
        return (
            <ViewContainer mode={this.props.mode} title="">
                <SearchView headCells={headCells} dataUrl={utils.isNull(this.props.dataUrl) ? "api/sims/moduleSetup/getsearch" : this.props.dataUrl}
                    deleteUrl={"api/sims/moduleSetup/RemoveModule"} useDeletePost={true}
                    entityViewPath='/moduleSetup' customMessage={this.props.customMessage} clearPress={(e) => { this.clearSearch(e) }}
                    model={this.state.model} toolbarConfig={this.toolbarConfig} modelClearTemplate={modelTemplate}
                    searchParameters={this.searchParameters} onLookupValueChange={this.props.onLookupValueChange}
                    descriptionProp="ModuleCode" mode={this.props.mode} allowClear={this.props.allowClear}
                    history={this.props.history} multiSelect={this.props.multiSelect}
                    hasButtonClickHandler={true} buttonClickHandler={this.handleToolbarButtonClick}
                    keyUpSwitch={this.state.keyUpSwitch} 
                    title='Modules' 
                    selectionCallbackMode={this.props.selectionCallbackMode}
                    promptTitle={"Remove Module"}
                    promptContent={"Removing the module is a permanent action and the module will not be available going forward. Are you sure you want to remove this module?"}
                >
                    <ModuleSetupSearchForm
                        data={this.state.model} 
                        onKeyUp={(e) => { this.onkeyup(e) }}
                        valueChangeHandler={(values) => {
                            let model = { ...values };
                            if (!utils.isNull(this.props.moduletype)) {
                                model.ModuleType = this.props.moduletype;
                            }

                            if (JSON.stringify(this.state.model) !== JSON.stringify(model)) {
                                this.setState({ model: model });
                            }
                        }}
                    />
                </SearchView>  
            </ViewContainer>    
        );
    }
}


export default withRouter(withMenuPermission(ModuleSetupSearch));
